const projects = [
  {
    title: '50 Projects 50 Days',
    link: 'https://lickoneyou.github.io/50projectsCarousel/',
    img: './images/projects/50projects50days.png',
    github: 'https://github.com/lickoneyou/50projects50days',
  },
  {
    title: 'MovieSearchApp',
    link: 'https://movie-search-app-azure.vercel.app/',
    img: './images/projects/MovieSearchApp.png',
    github: 'https://github.com/lickoneyou/MovieSearchApp',
  },
  {
    title: 'React ToDo',
    link: 'https://lickoneyou.github.io/React_ToDo/',
    img: './images/projects/ToDoReact.png',
    github: 'https://github.com/lickoneyou/React_ToDo/',
  },
  {
    title: 'React Cyberpunk',
    link: 'https://lickoneyou.github.io/Cyberpunk/',
    img: './images/projects/cyberpunk.png',
    github: 'https://github.com/lickoneyou/Cyberpunk/',
  },
  {
    title: '15 puzzle',
    link: 'https://lickoneyou.github.io/15puzzle/',
    img: './images/projects/15puzzle.png',
    github: 'https://github.com/lickoneyou/15puzzle',
  },
  {
    title: 'Race',
    link: 'https://lickoneyou.github.io/Race/',
    img: './images/projects/Race.png',
    github: 'https://github.com/lickoneyou/Race/',
  },
  {
    title: 'React|Redux Portfolio',
    link: 'https://lickoneyou.github.io/Portfolio/',
    img: './images/projects/redux-reactPortfolio.png',
    github: 'https://github.com/lickoneyou/Portfolio/',
  },
  {
    title: 'React|Redux Store',
    link: 'https://lickoneyou.github.io/Store/',
    img: './images/projects/store.png',
    github: 'https://github.com/lickoneyou/Store/',
  },
  {
    title: 'Interview Questions App',
    link: 'https://interview-questions-app-snowy.vercel.app/',
    img: './images/projects/iqa.png',
    github: 'https://github.com/lickoneyou/interviewQuestionsApp/',
  },
  {
    title: 'Museum',
    link: 'https://lickoneyou.github.io/Museum/',
    img: './images/projects/museum.png',
    github: 'https://github.com/lickoneyou/Museum',
  },
  {
    title: 'Go Games',
    link: 'https://lickoneyou.github.io/Gogames/',
    img: './images/projects/Gogames.png',
    github: 'https://github.com/lickoneyou/Gogames',
  },
  {
    title: 'OMDBMovie VUE/VUEX',
    link: 'https://lickoneyou.github.io/OMDBmovies/',
    img: './images/projects/omdbMovie.png',
    github: 'https://github.com/lickoneyou/OMDBmovies',
  },
  {
    title: 'Classic Snake Game',
    link: 'https://lickoneyou.github.io/classicSnakeGame/',
    img: './images/projects/snakeGame.png',
    github: 'https://github.com/lickoneyou/classicSnakeGame',
  },
  {
    title: 'Makeunion Tasks',
    img: './images/projects/mut.jpg',
    github: 'https://github.com/lickoneyou/Makeunion_Tasks',
  },
  {
    title: 'HOUSE OF GAMBLING',
    link: 'https://lickoneyou.github.io/HouseOfGambling/',
    img: './images/projects/HoG.png',
    github: 'https://github.com/lickoneyou/HouseOfGambling',
  },
  {
    title: 'Shelter',
    link: 'https://lickoneyou.github.io/Shelter/',
    img: './images/projects/Shelter.png',
    github: 'https://github.com/lickoneyou/Shelter',
  },
  {
    title: 'Learn WordPress',
    img: './images/projects/Wordpress.jpg',
    github: 'https://github.com/lickoneyou/WordPress',
  },
  {
    title: 'PHP Tasks',
    img: './images/projects/phpTasks.jpg',
    github: 'https://github.com/lickoneyou/PHP_TASKS',
  },
  {
    title: 'RUMTIBET',
    link: 'https://lickoneyou.github.io/RUMTIBET/',
    img: './images/projects/rumtibet.png',
    github: 'https://github.com/lickoneyou/RUMTIBET',
  },
  {
    title: 'DART SERVICE MANAGER',
    link: 'https://lickoneyou.github.io/DART_SERVICE_MANAGER/',
    img: './images/projects/dart.png',
    github: 'https://github.com/lickoneyou/DART_SERVICE_MANAGER',
  },
  {
    title: 'Momentum',
    link: 'https://lickoneyou.github.io/momentum/',
    img: './images/projects/momentum.png',
    github: 'https://github.com/lickoneyou/momentum',
  },
  {
    title: 'JS ToDo',
    link: 'https://lickoneyou.github.io/ToDo_JS/',
    img: './images/projects/ToDoJS.png',
    github: 'https://github.com/lickoneyou/ToDo_JS',
  },
  {
    title: 'Plants',
    link: 'https://lickoneyou.github.io/Plants/',
    img: './images/projects/plants.png',
    github: 'https://github.com/lickoneyou/Plants',
  },
  {
    title: 'Redux Todo',
    link: 'https://lickoneyou.github.io/ReduxTodo/',
    img: './images/projects/reduxTodo.png',
    github: 'https://github.com/lickoneyou/ReduxTodo',
  },
  {
    title: 'My Guides',
    link: 'https://lickoneyou.github.io/showcase-of-cheat-sheets/',
    img: './images/projects/showcase-of-cheat-sheets.png',
    github: 'https://github.com/lickoneyou/showcase-of-cheat-sheets/',
  },
  {
    title: 'Allods Online',
    link: 'https://lickoneyou.github.io/Allods_Online/',
    img: './images/projects/allods.png',
    github: 'https://github.com/lickoneyou/Allods_Online',
  },
]

export default projects
